// Load 3rd party scripts
window.$ = window.jQuery = require("jquery");
require("bootstrap");
require("liveaddress");
// Load Headroom globally then the jQuery plugin
window.Headroom = require("headroom.js");
require("headroom.js/dist/jQuery.headroom.js");

// Include our scripts
require("./js/offset.js");
window.crs = require("./js/crs.min.js");
require("./js/viewport.js");
require("./js/cookies.js");
require("./js/jquery.stuck.js");
require("./js/autofillbyip.js");
//require("moment");
//require("tempusdominus-bootstrap-4");
require("./js/site.js");
